import { oldTestBooks } from '../store/data/index';
import { newTestBooks } from '../store/data/index';

export const SearchVerse = {
    data() {
        return {
            bookDetails: [],
            oldTSelected: null,
            oldTBookKey: '0',
            newTBookKey: '0',
            selectedChapter: '',
            selectedVerse: '',
            jesusChapterVerse: '',
            bookModalVisible: false,
            chapterModalVisible: false,
            oldTestBooks: oldTestBooks.books,
            newTestBooks: newTestBooks.books
        }
    },
    methods: {
        closeBookModal() {
            this.bookModalVisible = false;
        },
        closeChapterModal() {
            this.chapterModalVisible = false;
        },
        closeVerseModal() {
            this.verseModalVisible = false;
        },
        updateBook(bookname, key) {
            if(this.$store.getters.getOldTSelected) {
                this.$store.dispatch('updateOldTestamentBookName',bookname);
                this.oldTBookKey = '' + key + '';
            } else {
                this.$store.dispatch('updateNewTestamentBookName',bookname);
                this.newTBookKey = '' + key + '';
            }
            this.closeBookModal();
            this.selectedChapter = 1;
            this.selectedVerse = 1;
            this.oldTChapterKey = 1;
            this.newTChapterKey = 1;            
        },
        updateChapter(num) {
            if(this.$store.getters.getOldTSelected) {
                this.oldTChapterKey = '' + num + '';
            } else {
                this.newTChapterKey = '' + num + '';
            }
            this.selectedChapter = num;
            this.closeChapterModal();
        },
        updateVerse(num) {
            this.selectedVerse = num;
            this.closeVerseModal();
        },
        updateJesusChapterAndVerse(num, testament) {
            if (testament == 'oldTestament') {
                this.oldJesusChapterVerse = num;
            } else {
                this.newJesusChapterVerse = num;
            }
            this.closeChapterModal();
        },
        fetchData(type) {
            this.$store.dispatch('setLoadingState', true);
            let url = '';
            const oldTestament = this.$store.getters.getOldTSelected;
            const bibleApiUrl = 'https://bible-api.com/';
                        
            if (type == 'JustJesus') {
                if (oldTestament) {
                    url = bibleApiUrl + this.$store.state.oldTBookname + this.oldJesusChapterVerse;
                    if (!this.$store.getters.getEsvState) {
                        url += '?translation=kjv';
                    } 
                } else {
                    url = bibleApiUrl  + this.$store.state.newTBookname + this.newJesusChapterVerse;
                    if (!this.$store.getters.getEsvState) {
                        url += '?translation=kjv';
                    }
                }
            } else {
                if (oldTestament) {
                    url = bibleApiUrl + this.$store.state.oldTBookname + this.selectedChapter;

                    if (this.$store.getters.getSearchByState != 'chapter') {
                        url += ':' + this.selectedVerse;
                    } else {
                        url += ':1-' + this.oldTestBooks[this.oldTBookKey].chapterVerseCount[this.oldTChapterKey];
                    }

                    if (!this.$store.getters.getEsvState) {
                         url += '?translation=kjv';
                    }
                } else {
                    url = url = bibleApiUrl + this.$store.state.newTBookname + this.selectedChapter;

                    if (this.$store.getters.getSearchByState != 'chapter') {
                        url += ':' + this.selectedVerse;
                    } else {
                        url += ':1-' + this.newTestBooks[this.newTBookKey].chapterVerseCount[this.newTChapterKey];
                    }

                    if (!this.$store.getters.getEsvState) {
                        url += '?translation=kjv';
                    }
                }
            }

            // Remove 'St.' from url
            let newUrl = url.replace('St.','');

            this.$http.get(newUrl)
            .then(response => {
                this.$store.dispatch('setLoadingState', false);
                const resObj = response.data.verses;

                if (type != 'favourites') {
                    this.bookDetails = [];
                }

                let chapterAndVerse = '';
                let currentBook = '';
                let currentChapter = '';
                let currentVerseNum = '';
                let currentVerse = '';

                resObj.forEach(el => {
                    for (let key in el) {
                        if (key == 'book_name') {
                            currentBook = el[key];
                        } else if (key == 'chapter') {
                            currentChapter = el[key];
                        } else if (key == 'verse') {
                            currentVerseNum = el[key];
                        } else if (key == 'text') {
                            currentVerse= el[key];
                        }
                    }
                    
                    if (currentBook == 'Matthew' || currentBook == 'Mark' || currentBook == 'Luke' || currentBook == 'John') {
                        currentBook = 'St.' + currentBook;
                    }

                    chapterAndVerse = currentChapter + ':' + currentVerseNum;
                    this.bookDetails.push({ bookName: currentBook, chapterAndVerse: chapterAndVerse, verseText: currentVerse });
                    this.$store.dispatch('updateCurrentVerse', { bookName: currentBook, chapterAndVerse: chapterAndVerse, verseText: currentVerse });
                });

            }, error => {
                this.$store.dispatch('setLoadingState', false);
                console.log(error);
            });
        }
    },
    computed: {
        oldTestamentBookName() {
            return this.$store.getters.getOldTestamentBookName;
        },
        newTestamentBookName() {
            return this.$store.getters.getNewTestamentBookName;
        }
    }
}


// WEBPACK FOOTER //
// ./src/mixins/SearchVerseMixin.js